<template>
  <div class="crm-dashboard">
    <el-card class="data-simple" shadow="never">
      <div slot="header">
        <span>用户统计</span>
      </div>
      <el-date-picker :clearable="false" v-model="dashBoardForm.date1" class="mb10" @change="userStatisticsFun" value-format="yyyy-MM-dd" type="daterange" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      <el-row :gutter="20">
        <el-col :xs="24" :md="12" :lg="4">
          <div>
            <el-card class="data-card" shadow="always">
              <div class="data-block">
                <div class="value">{{userStatisticsData.addUserCount}}</div>
                <div class="label">新增用户</div>
              </div>
            </el-card>
          </div>
        </el-col>
        <el-col :xs="24" :md="12" :lg="4">
          <div>
            <el-card class="data-card" shadow="always">
              <div class="data-block">
                <div class="value">{{userStatisticsData.totalUserCount}}
                </div>
                <div class="label">总用户</div>
              </div>
            </el-card>
          </div>
        </el-col>
        <el-col :xs="24" :md="12" :lg="4">
          <div>
            <el-card class="data-card" shadow="always">
              <div class="data-block">
                <div class="value">
                    {{userStatisticsData.activeUserCount}}
                </div>
                <div class="label">活跃用户</div>
              </div>
            </el-card>
          </div>
        </el-col>
      </el-row>
    </el-card>
    <el-card class="data-simple" shadow="never">
      <div slot="header">
        <span>增长活动趋势</span>
      </div>
      <el-date-picker
        v-model="dashBoardForm.date4"
        value-format="yyyy-MM"
        type="month"
        placeholder="请选择日期"
        @change="userTrendFun"
        :clearable="false"
      ></el-date-picker>
      <el-card class="mt10" style="height: 362px">
        <!-- <BusinessTrendChart :chartData="trendData"/> -->
        <div id="line" style="height:340px;width:100%" />
     </el-card>
    </el-card>

    <el-card class="data-simple" shadow="never">
      <div slot="header">
        <span>名片统计</span>
      </div>
      <el-date-picker :clearable="false" v-model="dashBoardForm.date2" @change="cardStatisticsFun" class="mb10" value-format="yyyy-MM-dd" type="daterange" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>

      <el-row :gutter="10">
        <el-col :xs="24" :md="12" :lg="4">
          <div>
            <el-card class="data-card" shadow="always">
              <div class="data-block">
                <div class="value">{{cardStatisticsData.addCardCount}}</div>
                <div class="label">新增名片</div>
              </div>
            </el-card>
          </div>
        </el-col>
        <el-col :xs="24" :md="12" :lg="4">
          <div>
            <el-card class="data-card" shadow="always">
              <div class="data-block">
                <div class="value">{{cardStatisticsData.totalCardCount}}</div>
                <div class="label">累计名片</div>
              </div>
            </el-card>
          </div>
        </el-col>
        <el-col :xs="24" :md="12" :lg="4">
          <div>
            <el-card class="data-card" shadow="always">
              <div class="data-block">
                <div class="value">{{cardStatisticsData.shareCardCount}}</div>
                <div class="label">分享量</div>
              </div>
            </el-card>
          </div>
        </el-col>
        <el-col :xs="24" :md="12" :lg="4">
          <div>
            <el-card class="data-card" shadow="always">
              <div class="data-block">
                <div class="value">{{cardStatisticsData.collectCardCount}}</div>
                <div class="label">收藏量</div>
              </div>
            </el-card>
          </div>
        </el-col>
      </el-row>
    </el-card>
    <el-card class="data-simple" shadow="never">
        <el-table :data="cardDataList">
            <el-table-column label="名称" align="center" prop="tenantFullName"></el-table-column>
            <el-table-column label="名片数" align="center" prop="count"></el-table-column>
        </el-table>
        <pagination v-show="total>0" :total="total" :page.sync="cardParams.pageNum" :limit.sync="cardParams.pageSize" @pagination="cardRankingStatisticsFun"/>
    </el-card>
    <el-card class="data-simple" shadow="never">
      <div slot="header">
        <span>内容统计</span>
      </div>
      <el-date-picker :clearable="false" v-model="dashBoardForm.date3" @change="contentDtaeChangeFun" class="mb10" value-format="yyyy-MM-dd" type="daterange" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      <el-row :gutter="10">
        <el-col :xs="24" :md="12" :lg="4">
          <div>
            <el-card class="data-card" shadow="always">
              <div class="data-block">
                <div class="value">{{contentStatisticsData.addArtcleCount}}</div>
                <div class="label">新增文章</div>
              </div>
            </el-card>
          </div>
        </el-col>
        <el-col :xs="24" :md="12" :lg="4">
          <div>
            <el-card class="data-card" shadow="always">
              <div class="data-block">
                <div class="value">{{contentStatisticsData.addProductCount}}</div>
                <div class="label">新增产品</div>
              </div>
            </el-card>
          </div>
        </el-col>
        <el-col :xs="24" :md="12" :lg="4">
          <div>
            <el-card class="data-card" shadow="always">
              <div class="data-block">
                <div class="value">{{contentStatisticsData.addCaseCount}}</div>
                <div class="label">新增案例</div>
              </div>
            </el-card>
          </div>
        </el-col>
        <el-col :xs="24" :md="12" :lg="4">
          <div>
            <el-card class="data-card" shadow="always">
              <div class="data-block">
                <div class="value">{{contentStatisticsData.readCount}}</div>
                <div class="label">浏览人次</div>
              </div>
            </el-card>
          </div>
        </el-col>
        <el-col :xs="24" :md="12" :lg="4">
          <div>
            <el-card class="data-card" shadow="always">
              <div class="data-block">
                <div class="value">{{contentStatisticsData.pageViews}}</div>
                <div class="label">浏览人数</div>
              </div>
            </el-card>
          </div>
        </el-col>
      </el-row>
    </el-card>
    <el-card class="data-simple" shadow="never">
        <el-table :data="contentDataList">
            <el-table-column label="排名" align="center" prop="rank"></el-table-column>
            <el-table-column label="内容名称" align="center" prop="title"></el-table-column>
            <el-table-column label="类型" align="center" prop="typeName"></el-table-column>
            <el-table-column label="作者" align="center" prop="tenantName"></el-table-column>
            <el-table-column label="浏览人次" align="center" prop="readCount"></el-table-column>
            <el-table-column label="浏览人数" align="center" prop="pageViews"></el-table-column>
        </el-table>
    </el-card>
  </div>
</template>

<script>
import { userStatistics, cardStatistics, cardRankingStatistics, contentStatistics, contentRankingStatistics, userTrend } from '@/api/saas/package'
import { amountFormat } from '@/utils/index'
import * as echarts from 'echarts';

export default {
  name: "index",
  props: {
  },
  data() {
    return {
      amountFormat,
      activeName: '1',
      trendData: {
        dataType: 'trend',
        data: []
      },
      userStatisticsData: { // 用户统计
      },
      cardStatisticsData: { // 名片统计
      },
      contentStatisticsData: { // 内容统计
      },
      cardDataList: [], // 名片统计列表
      contentDataList: [], // 内容统计列表
      total: 0,
      cardParams: {
        pageSize: 10,
        pageNum: 1,
      },
      dashBoardForm: {
        date1: [],
        date2: [],
        date3: [],
        date4: ''
      },

    };
  },
  components: {
  },
  mounted() {
    // 默认本月1号到当天
    let today = new Date();
    let month = today.getMonth() < 9 ? "0" + (today.getMonth() + 1) : today.getMonth() + 1
    let day = today.getDate() < 10 ? "0" + today.getDate() : today.getDate()
    let todayStr = today.getFullYear() + "-" + month + "-" + day
    let date = [today.getFullYear() + "-" + month + "-01", today.getFullYear() + "-" + month + "-" + day]
    this.dashBoardForm.date1 = date
    this.dashBoardForm.date2 = date
    this.dashBoardForm.date3 = date
    this.dashBoardForm.date4 = today.getFullYear() + "-" + month
    this.userStatisticsFun()
    this.cardStatisticsFun()
    this.contentStatisticsFun()
    this.cardRankingStatisticsFun()
    this.contentRankingStatisticsFun()
    this.userTrendFun() // 用户统计趋势图
  },
  methods: {
    contentDtaeChangeFun() {
      this.contentRankingStatisticsFun()
      this.contentStatisticsFun()
    },
    setOptions(xData, yData1, yData2) {
      let chartDom = document.getElementById('line');
      let myChart = echarts.init(chartDom);
      let option
      option = {
        xAxis: {
          data: xData,
          boundaryGap: false,
          axisTick: {
            show: false
          }
        },
        grid: {
          left: '3%',
          right: '3%',
          bottom: 20,
          top: 30,
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          padding: [5, 10]
        },
        yAxis: {
          axisTick: {
            show: false
          }
        },
        legend: {
          data: ['新增用户', '活跃用户']
        },
        series: [{
            name: '新增用户',
            type: 'line',
            smooth: true,
            data: yData2
        },
        {
            name: '活跃用户',
            type: 'line',
            smooth: true,
            data: yData1
        }]
      }
      option && myChart.setOption(option);
    },

    userTrendFun () {
      userTrend({
        yearMonth: this.dashBoardForm.date4
      }).then(response => {
        console.log('response-', response)
          let data = response.data,
              xData = [],
              yData1 = [],
              yData2 = []
          data.activeUserCountList.forEach(item => {
            xData.push(item.time)
            yData1.push(item.count)
          })
          data.addUserCountList.forEach(item => {
            yData2.push(item.count)
          })
          this.setOptions(xData, yData1, yData2)
          // this.contentStatisticsData = response.data;
      });
    },
      // 账户统计，到期统计
    generalInfo() {
        generalInfo().then(response => {
            this.contentStatisticsData = response.data;
        });
    },
    // 销售统计
    userStatisticsFun() {
        userStatistics({
            timeStart: this.dashBoardForm.date1[0],
            timeEnd: this.dashBoardForm.date1[1]
        }).then(response => {
            this.userStatisticsData = response.data;
        });
    },
    // 名片统计
    cardStatisticsFun() {
        cardStatistics({
            timeStart: this.dashBoardForm.date2[0],
            timeEnd: this.dashBoardForm.date2[1]
        }).then(response => {
            this.cardStatisticsData = response.data;
        });
    },
    // 名片统计列表
    cardRankingStatisticsFun () {
        cardRankingStatistics({
            ...this.cardParams,
            // timeStart: this.dashBoardForm.date2[0],
            // timeEnd: this.dashBoardForm.date2[1]
        }).then(response => {
            this.cardDataList = response.rows;
            this.total = response.total
        });
    },
    // 内容统计
    contentStatisticsFun() {
        contentStatistics({
            timeStart: this.dashBoardForm.date3[0],
            timeEnd: this.dashBoardForm.date3[1]
        }).then(response => {
            this.contentStatisticsData = response.data;
        });
    },
    // 内容统计
    contentRankingStatisticsFun() {
        contentRankingStatistics({
            timeStart: this.dashBoardForm.date3[0],
            timeEnd: this.dashBoardForm.date3[1]
        }).then(response => {
            this.contentDataList = response.data;
        });
    },
    handleClick(){

    }
  }
};
</script>

<style lang='scss'>
.crm-dashboard {
  .data-simple {
    margin: 0 10px 10px 10px;
    border: 0;
    .data-card {
      cursor: pointer;
      margin: 2px 0;
      .data-block {
        height: 100px;
        text-align: center;
        .label {
          font-weight: 500;
          padding-top: 30px;
        }
        .value {
          font-weight: 400;
          padding-top: 20px;
        }
      }
    }
    .data-card:hover {
      color: #4480F3;
      border-color: #c7d9fb;
      background-color: #ecf2fe;
    }
  }
  .data-funnel {
    border: 0;
    margin: 10px;
  }

  .moreBtn {
    float: right;
    margin-top: -25px;
  }

  .dynamicList {
    border-bottom: 1px solid #e8e6e6;
    margin-top: 12px;
    padding-bottom: 10px;
    font-size: 13px;
  }

  .dynamicList2 {
    border-bottom: 1px solid #e8e6e6;
    margin-top: 12px;
    padding-bottom: 10px;
    font-size: 14px;
  }

  .cardLeftTopTitle {
    color: #9ea1a7;
    font-size: 14px
  }

  .dynamicCard {
    min-height: 100px;
    height: 220px;
  }

  .noDataTip {
    margin-left: 45%;
    margin-top: 15px;
    color: #b7b5b5;
    font-size: 14px;
  }

  .dynamicContent {
    margin-top: 8px;
    width:96%;
    overflow:hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow:ellipsis;
  }

  .toDetailBtn {
    float: right;
    margin-top: -15px;
    padding: 0px;
  }

  .dynamicCreatTime {
    color: #969494;
  }

  .yearPicker {
    margin-top: -15px;
  }
}
</style>
